import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-cube",
  "use": "spr-cube-usage",
  "viewBox": "0 0 68 78",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 68 78\" id=\"spr-cube\"><defs><path id=\"spr-cube_a\" d=\"M282 724l34-19 34 19v40l-34 19-34-19v-40zm35 18.44v1.97l4.95 2.7-.96 1.75-3.99-2.18v33.47l30.3-16.94-4.25-2.31.96-1.76 3.99 2.17v-36.2zm-2 37.71v-33.47l-3.99 2.18-.96-1.76 4.95-2.7v-1.96l-31-17.32v36.2l3.99-2.18.96 1.76-4.25 2.31zM286.1 724l29.9 16.7 29.9-16.7-28.9-16.15v5.36h-2v-5.36zm30.9 12.07h-2v-6.71h2zm0-11.43h-2v-6.71h2zm22.34 34.23l-5.46-2.98.95-1.76 5.47 2.99zm-9.17-5l-5.47-2.99.96-1.75 5.46 2.98zm-37.51 5l-.96-1.75 5.47-2.99.95 1.76zm9.17-5l-.95-1.76 5.46-2.98.96 1.75z\" /></defs><use fill=\"#fff\" xlink:href=\"#spr-cube_a\" transform=\"translate(-282 -705)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/cube.svg
// module id = 251
// module chunks = 0